import { define } from 'wicked-elements';

// CSS class to hide the tab bar
const HIDDEN_CLASS = 'tabbar-hidden';
const GRACE_TOP = 50; // px

function shouldHideTabBar(current, last) {
  // Only hide if scrolling down, not at bottom, and not near the top
  return (
    current > last &&
    current > GRACE_TOP &&
    (window.innerHeight + window.scrollY) < document.body.offsetHeight - 2
  );
}

define('[data-component="pwa-tabbar"]', {
  init() {
    this.lastScrollY = window.scrollY;
    this.ticking = false;
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll, { passive: true });

    // Prefetch all tab bar destinations
    const tabLinks = this.element.querySelectorAll('a[href]');
    if (!window._prefetched) window._prefetched = new Set();
    tabLinks.forEach(link => {
      const url = link.href;
      if (!window._prefetched.has(url)) {
        if (window.GPLA_APP && typeof window.GPLA_APP.load === 'function') {
          window.GPLA_APP.load(url);
        } else {
          fetch(url, { credentials: 'same-origin' });
        }
        window._prefetched.add(url);
      }
    });
  },
  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        const atBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 2;
        if (shouldHideTabBar(currentScrollY, this.lastScrollY) && !atBottom) {
          document.body.classList.add(HIDDEN_CLASS);
        } else {
          document.body.classList.remove(HIDDEN_CLASS);
        }
        this.lastScrollY = currentScrollY;
        this.ticking = false;
      });
      this.ticking = true;
    }
  },
  destroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }
}); 